export const navLinkItem = {
  fontWeight: 500,
  color: "#12141D",
  cursor: "pointer",
  ":hover": {
    transform: "scale(1.1)",
    borderBottom: ".25rem solid #12141D",
    paddingBottom: ".5rem",
    transition: ".3s",
  },
};

export const signInButton = { textTransform: "none", marginRight: "2rem" };

export const signInText = { fontWeight: 500, color: "#222222" };

export const getYourCardButton = {
  textTransform: "none",
  padding: ".8rem 1.25rem",
  background: "#0B0B0B",
  color: "#ffffff",
  borderRadius: ".8rem",
  ":hover": {
    background: "#0B0B0B",
    transition: ".3s",
  },
};
